module.exports = __webpack_public_path__ + "static/media/running-staire.69006023.png";